import { Flex } from '@duxton-web/ui';
import React from 'react';

const FlexRow = ({ children }) => (
  <Flex gap={16} vertical={false}>
    {children}
  </Flex>
);

export default FlexRow;
